import { POST } from './api.utility';
export async function createPaymentIntent(orderData) {
    try {
        const response = await POST('/create_payment_intent', {}, orderData);
        return response;
    } catch (e) {
        console.log({ e })
    }
}